'use client';

import * as yup from 'yup';

export const loginFormSchema = yup.object({
  phoneNumber: yup.string().required('Phone number is a required field').default(''),
  password: yup.string().required('Password is a required field').default('')
});

export type LoginFormDto = yup.InferType<typeof loginFormSchema>;

export enum LoginFormFieldNames {
  phoneNumber = 'phoneNumber',
  password = 'password'
}
